// este bloque es para recorrer data(conbackground) que tiene 90vh de altura
import React, { useEffect } from "react"
import { Block, Boton } from "./style"
import $ from "jquery"
const Bloque = props => {
  useEffect(() => {
    $(".row button:first-child").attr("id", "buton1")
    $(".row button:nth-child(2)").attr("id", "buton2")
    console.log("sa")
  })
  const clickHref = e => {
    console.log(e.target.id)

    if (e.target.id === "MANTENIMIENTO" || e.target.id === "GARANTÍA") {
      $("#buton1").trigger("click")
      console.log("mantenida")
    }
    if (e.target.id === "ASESORÍA" || e.target.id === "VENTASYREPUESTOS") {
      // e.preventDefault();
      $("#buton2").trigger("click")
      console.log("asosorada")
    }
  }

  return (
    <Block>
      {props.data
        ? props.data.map((dtPorQue, key) => {
            const { title, text, image } = dtPorQue
            let title_s_espacios = title.replace(/\s+/g, "")
            return (
              <div
                className="wrapper"
                style={{ backgroundImage: `url(${image})` }}
                key={key}
              >
                <div className="container">
                  <div className="card-body">
                    <h3
                      data-aos="fade-right"
                      data-aos-duration="1000"
                      className="card-body-title"
                    >
                      {title}
                    </h3>
                    <p
                    data-aos="fade-right"
                    data-aos-duration="1500"
                    className="card-body-text"
                    >
                      {text}
                    </p>
                    {props.boton ? (
                      <div
                      data-aos="fade-right"
                    data-aos-duration="1800"
                      >
                        <Boton
                          id={title_s_espacios}
                          onClick={clickHref}
                          href="#contact"
                        >
                          FORMULARIO
                        </Boton>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )
          })
        : null}
    </Block>
  )
}

export default Bloque
